/* product-anchor-nav.js — nav ancrée fiche produit (refonte S2, plan 2026-07-06). */
/* Rôles : (1) offset sticky DYNAMIQUE (top + scroll-padding) calé sur la hauteur du header ; */
/* (2) état actif au clic, VERROUILLÉ jusqu'au prochain scroll manuel ; (3) scrollspy au scroll libre. */
/* Le sticky est natif CSS (position:sticky). Le scrollspy = listener scroll PASSIF throttlé en rAF. */
(function () {
  function getNav() {
    return document.querySelector('.product-anchor-nav');
  }

  // Ligne de référence sous laquelle une section devient "courante" = header + nav sticky (= scroll-padding).
  function currentOffset(nav) {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--anchor-nav-top'), 10);
    return (isNaN(v) ? 118 : v) + Math.round(nav.getBoundingClientRect().height);
  }

  // Bas RÉEL du header fixe (#SiteHeader). On NE se fie PAS à .main__menu (contra anti-pattern
  // CLAUDE.md #1, qui visait le sticky du bandeau back) : .main__menu s'écrase à 0 au scroll et ne
  // vaut que 101px en tablette (≤~990px) alors que le header y ajoute la rangée « Retour aux
  // résultats » et descend à 162px → la nav se calait dessous, masquée. #SiteHeader.bottom est lui
  // stable et exact à toutes largeurs/scroll (desktop 118 / tablette 162) et suit le bandeau back + FMD.
  function headerBottom() {
    var h = document.querySelector('#SiteHeader');
    if (h == null) return 118;
    var b = Math.round(h.getBoundingClientRect().bottom);
    return b > 0 ? b : 118;
  }

  // (1) Offset dynamique : pose --anchor-nav-top (top du sticky) et ajuste scroll-padding-top pour
  // que les ancres dégagent header + nav. Recalé sur load/resize ET au scroll (le header peut
  // changer de hauteur : bandeau « Retour aux résultats », variantes FMD…).
  function applyOffsets(nav, hb) {
    var root = document.documentElement;
    root.style.setProperty('--anchor-nav-top', hb + 'px');
    var financing = document.getElementById('product-financing-options');
    // Nav visible (desktop) → l'ancre dégage header + nav. Nav masquée (mobile) → scroll-padding global.
    if (getComputedStyle(nav).display !== 'none') {
      root.style.scrollPaddingTop = hb + Math.round(nav.getBoundingClientRect().height) + 8 + 'px';
      // #product-financing-options porte un scroll-margin-top:144px (utile en mobile SANS nav pour
      // dégager le header). Nav active → le scroll-padding ci-dessus couvre déjà header+nav, les deux
      // s'additionneraient → l'ancre « Financement » atterrirait ~144px trop bas. On le neutralise.
      if (financing) financing.style.scrollMarginTop = '0px';
    } else {
      root.style.scrollPaddingTop = '';
      // Nav masquée → on rend le scroll-margin-top au CSS (144px) pour que l'ancre mobile dégage le header.
      if (financing) financing.style.scrollMarginTop = '';
    }
  }

  // Résout les liens de la nav vers leurs sections cibles présentes dans le DOM.
  function resolveEntries(nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('.product-anchor-nav__link'));
    return links
      .map(function (link) {
        var href = link.getAttribute('href') || '';
        var target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);
  }

  function setActive(entries, activeEntry) {
    for (var i = 0; i < entries.length; i++) entries[i].link.classList.remove('is-active');
    if (activeEntry) activeEntry.link.classList.add('is-active');
  }

  // (3) Scrollspy (scroll LIBRE) : dernière section dont le haut a franchi la ligne. +2px = marge
  // sub-pixel. Au bas de page, on force la dernière (une section courte en fin ne franchit jamais la ligne).
  function refreshActive(nav, entries) {
    if (!entries.length) return;
    var line = currentOffset(nav) + 8;
    var active = entries[0];
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].target.getBoundingClientRect().top <= line + 2) active = entries[i];
    }
    var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
    if (atBottom) active = entries[entries.length - 1];
    setActive(entries, active);
  }

  // Touches qui provoquent un scroll → relâchent le verrou de clic.
  function isScrollKey(k) {
    return (
      k === 'ArrowUp' ||
      k === 'ArrowDown' ||
      k === 'PageUp' ||
      k === 'PageDown' ||
      k === 'Home' ||
      k === 'End' ||
      k === ' ' ||
      k === 'Spacebar'
    );
  }

  function init() {
    var nav = getNav();
    if (!nav) return;
    var entries = resolveEntries(nav);
    var lastHb = headerBottom();
    applyOffsets(nav, lastHb);

    var spyOn = entries.length > 1;

    // (2) Verrou de clic : après un clic, la section cliquée reste active pendant le scroll
    // PROGRAMMATIQUE — le scrollspy ne l'écrase pas. Immunise contre scroll-margin-top propre à
    // une section (ex. #product-financing-options = 144px), layout-shift post-jump (images lazy),
    // sous-scroll et arrondi sub-pixel, qui faisaient retomber le highlight sur la section d'avant.
    // Relâché au 1er geste de scroll MANUEL (molette / tactile / clavier) → le scrollspy reprend.
    var clickLock = false;
    function spy() {
      if (clickLock) return;
      if (spyOn && getComputedStyle(nav).display !== 'none') refreshActive(nav, entries);
    }

    nav.addEventListener('click', function (e) {
      var link = e.target.closest('.product-anchor-nav__link');
      if (!link) return;
      var match = null;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].link === link) match = entries[i];
      }
      setActive(entries, match);
      clickLock = true;
    });

    function release() {
      clickLock = false;
    }
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('touchmove', release, { passive: true });
    window.addEventListener('keydown', function (e) {
      if (isScrollKey(e.key)) release();
    });

    spy();

    // Scrollspy + offset dynamique : listener scroll PASSIF throttlé en rAF (pas de layout thrash).
    // On recale l'offset SEULEMENT si le header a changé de hauteur (détection de changement →
    // aucune écriture CSS quand il est stable, cas courant) : suit le bandeau « Retour aux résultats ».
    var scrolling = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scrolling) return;
        scrolling = true;
        requestAnimationFrame(function () {
          // Nav masquée (mobile, desktop-only ≥990px) → feature inactive : on n'exécute NI la mesure
          // header (getBoundingClientRect) NI applyOffsets à chaque frame. Évite un recalc style continu
          // sur le parcours mobile (déjà fragile au CWV) où le header collapse ferait changer hb sans cesse.
          if (getComputedStyle(nav).display === 'none') {
            scrolling = false;
            return;
          }
          var hb = headerBottom();
          if (hb !== lastHb) {
            lastHb = hb;
            applyOffsets(nav, hb);
          }
          spy();
          scrolling = false;
        });
      },
      { passive: true },
    );

    // Layout définitif (polices/images) + resize → recalage offset et actif.
    var raf;
    function recompute() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        lastHb = headerBottom();
        applyOffsets(nav, lastHb);
        spy();
      });
    }
    window.addEventListener('load', recompute);
    window.addEventListener('resize', recompute);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
